import { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { EMAIL, PHONE_DISPLAY, PHONE_TEL, SITE_URL, SLOGAN, WHATSAPP_URL } from "./App";

const priorityServices = [
  {
    title: "Income Tax Filing",
    text: "Personal and business income tax returns, wealth statements, NTN updates and annual compliance.",
  },
  {
    title: "SECP Company Registration",
    text: "Private Limited, Single Member Company, partnership and startup registration with complete documentation.",
  },
  {
    title: "FBR, SRB, PRA & BRA Compliance",
    text: "Sales tax registration, monthly returns, withholding statements, portal corrections and notice handling.",
  },
  {
    title: "Bookkeeping & Bank Reconciliation",
    text: "International bookkeeping, bank reconciliations, ledgers, profit and loss reports, and audit-ready records.",
  },
];

const trustStats = [
  { value: "Intl.", label: "Bookkeeping and reconciliation experience" },
  { value: "PK", label: "Nationwide taxation and compliance" },
  { value: "360", label: "Compliance support approach" },
];

const seoKeywords = [
  "tax consultant in Lahore",
  "tax consultant Pakistan",
  "FBR tax filing",
  "SECP company registration",
  "NTN registration",
  "STRN registration",
  "sales tax return filing",
  "salary tax calculator Pakistan",
  "bookkeeping services Pakistan",
  "PSEB registration",
];

export default function Home() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <>
      <Helmet>
        <title>Tax Consultant in Lahore | Bookkeeping & Compliance | Axis Compliance Solutions</title>
        <meta
          name="description"
          content="Smart Finance, Clear Compliance. Get support for international bookkeeping, bank reconciliation, nationwide taxation, FBR filing, SECP registration and compliance."
        />
        <meta
          name="keywords"
          content="tax consultant Lahore, tax consultant Pakistan, international bookkeeping services, bank reconciliation services, FBR tax filing, SECP company registration, income tax return Pakistan, NTN registration, STRN registration, sales tax return filing, Axis Compliance Solutions"
        />
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:title" content="Tax Consultant in Lahore | Axis Compliance Solutions" />
        <meta
          property="og:description"
          content="Smart Finance, Clear Compliance. International bookkeeping and bank reconciliation experience with nationwide FBR, SECP, SRB, PRA, BRA, taxation and compliance services in Pakistan."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta property="og:image" content={`${SITE_URL}/hero-tax.jpg`} />
        <meta property="og:image:alt" content="Tax consultant reviewing business compliance documents" />
        <meta name="twitter:title" content="Tax Consultant in Lahore | Axis Compliance Solutions" />
        <meta
          name="twitter:description"
          content="International bookkeeping and nationwide FBR, SECP, tax and compliance support in Pakistan."
        />
        <meta name="twitter:image" content={`${SITE_URL}/hero-tax.jpg`} />
        <meta name="twitter:image:alt" content="Tax consultant reviewing business compliance documents" />
      </Helmet>

      <section className="relative isolate overflow-hidden bg-slate-950 text-white">
        <img
          src="/hero-tax.jpg"
          alt="Tax consultant reviewing business compliance documents"
          className="absolute inset-0 -z-10 h-full w-full object-cover opacity-[0.34]"
        />
        <div className="absolute inset-0 -z-10 bg-slate-950/78" />

        <div className="mx-auto grid min-h-[620px] max-w-7xl items-center gap-12 px-4 py-16 sm:py-20 lg:grid-cols-[1.1fr_0.9fr] lg:px-8">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-cyan-200">
              {SLOGAN}
            </p>
            <h1 className="mt-5 max-w-4xl text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-6xl">
              International bookkeeping and nationwide tax compliance for confident business decisions.
            </h1>
            <p className="mt-4 text-sm font-semibold uppercase tracking-[0.12em] text-cyan-100">
              FBR, SECP, SRB, PRA, BRA, NTN & STRN advisory
            </p>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-200">
              Axis Compliance Solutions helps clients with international bookkeeping and bank
              reconciliation, while supporting taxation, company registration, sales tax,
              audit support and regulatory compliance across Pakistan.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link className="btn-primary" to="/contact">
                Get a Free Consultation
              </Link>
              <a className="btn-secondary-dark" href={WHATSAPP_URL} target="_blank" rel="noreferrer">
                Chat on WhatsApp
              </a>
            </div>
            <div className="mt-10 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-3">
              {trustStats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-cyan-300 bg-white/8 p-4 backdrop-blur">
                  <strong className="block text-2xl font-semibold text-white">{stat.value}</strong>
                  <span className="text-sm text-slate-300">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-md border border-white/15 bg-white p-6 text-slate-900 shadow-2xl">
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-cyan-800">
              Quick assessment
            </p>
            <h2 className="mt-3 text-2xl font-semibold">Tell us what needs attention</h2>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              Send a short message and the team will respond with the right next step for tax,
              registration or compliance work.
            </p>
            <form action="https://formsubmit.co/sbaig1749@gmail.com" method="POST" className="mt-6 space-y-4">
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_subject" value="New Consultation Request" />
              <input className="field" type="text" name="name" placeholder="Full name" required />
              <input className="field" type="email" name="email" placeholder="Email address" required />
              <input className="field" type="tel" name="phone" placeholder="Mobile number" required />
              <select className="field" name="service" defaultValue="Tax filing">
                <option>Tax filing</option>
                <option>Company registration</option>
                <option>Sales tax and STRN</option>
                <option>Bookkeeping and bank reconciliation</option>
                <option>Other compliance matter</option>
              </select>
              <textarea className="field min-h-28" name="message" placeholder="Briefly describe your requirement" required />
              <button className="btn-primary w-full" type="submit" onClick={() => setSubmitted(true)}>
                Request Consultation
              </button>
            </form>
            {submitted && (
              <p className="mt-4 rounded-md bg-emerald-50 p-3 text-center text-sm font-medium text-emerald-800">
                Thank you. Your request has been prepared for submission.
              </p>
            )}
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-end">
            <div>
              <p className="eyebrow">What we handle</p>
              <h2 className="section-title">Tax and compliance support built for real business deadlines.</h2>
            </div>
            <p className="text-lg leading-8 text-slate-600">
              From international bookkeeping and bank reconciliation to individual income tax
              returns, company registration and monthly compliance calendars, the work is
              structured so documents, portals, filings and records stay aligned.
            </p>
          </div>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {priorityServices.map((service) => (
              <article key={service.title} className="service-card">
                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-slate-100">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 lg:grid-cols-2 lg:px-8">
          <div>
            <p className="eyebrow">Why clients choose Axis Compliance Solutions</p>
            <h2 className="section-title">A professional process for sensitive financial matters.</h2>
            <p className="mt-5 leading-8 text-slate-600">
              Every case is reviewed for the documents required, the relevant authority, filing
              timeline, risk areas and communication trail. That keeps the process easier to
              understand and easier to defend.
            </p>
          </div>
          <div className="grid gap-4">
            {[
              "Clear guidance before filing or registration starts",
              "Confidential handling of tax, income, wealth and business records",
              "Support for IRIS, eFBR, SECP, SRB, PRA, BRA and PSEB portals",
              "Practical reminders for renewals, returns and compliance deadlines",
            ].map((item) => (
              <div key={item} className="flex gap-3 rounded-md border border-slate-200 bg-white p-4 shadow-sm">
                <span className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-cyan-700" />
                <p className="font-medium text-slate-800">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          <div className="rounded-md bg-slate-950 px-6 py-10 text-white sm:px-10 lg:flex lg:items-center lg:justify-between">
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.12em] text-cyan-200">Ready to discuss your case?</p>
              <h2 className="mt-3 text-3xl font-semibold">Speak with a tax consultant today.</h2>
              <p className="mt-3 max-w-2xl text-slate-300">
                Call {PHONE_DISPLAY}, email {EMAIL}, or send your details for a consultation.
              </p>
            </div>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row lg:mt-0">
              <a className="btn-light" href={`tel:${PHONE_TEL}`}>Call Now</a>
              <Link className="btn-secondary-dark" to="/contact">Contact Page</Link>
            </div>
          </div>
          <div className="mt-8 flex flex-wrap gap-2">
            {seoKeywords.map((keyword) => (
              <span key={keyword} className="rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-600">
                {keyword}
              </span>
            ))}
          </div>
        </div>
      </section>

      <a
        href={WHATSAPP_URL}
        className="fixed bottom-5 right-5 z-40 inline-flex h-14 w-14 items-center justify-center rounded-full bg-emerald-600 p-3 shadow-xl transition hover:bg-emerald-700"
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <img src="/whatsapp-icon.png" alt="" className="h-7 w-7" />
      </a>
    </>
  );
}
